import React, { useMemo } from 'react';

import { Dialog, DialogContent } from '@material-ui/core';
import { useIsMobile } from '../../../../components/Mui3WidthProvider';
import { LinkAssetType } from '../../../../entities/LinkAssetType';

interface Props {
    open: boolean;
    onClose: () => void;
    autoPlay?: boolean;
    linkUrl: string;
    linkType: LinkAssetType;
}

export function ShowEmbeddedLinkDialog(props:Props){
    const isMobile = useIsMobile();
    const { linkType, linkUrl, autoPlay } = props;

    const contentUrl = useMemo(() => linkUrl.substring(`${linkType}://`.length), [linkType, linkUrl])
    const iframeHeight = useMemo(() => isMobile ? 'auto' : '315', [isMobile])
    const iframeWidth = useMemo(() => isMobile ? '300' : '550', [isMobile])

    if (linkUrl.indexOf(`${linkType}://`) !== 0 )
        return null

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogContent style={{
                    width: isMobile ? 300 : 550,
                    height: isMobile ? "auto" : 315,
                    overflow: 'hidden',
                    padding: 0
                }}
            >
               { linkType === LinkAssetType.SoundCloud &&
                    <iframe title="SoundCloud" frameBorder={0} height={iframeHeight} width={iframeWidth} scrolling="no" allow="autoplay" src={`https://w.soundcloud.com/player/?url=${contentUrl}&color=%231967d2&auto_play=${autoPlay}&hide_related=false&show_comments=false&show_user=true&show_reposts=false&show_teaser=true&visual=true`}/>
               }
               { linkType === LinkAssetType.YouTube &&
                    <iframe title="YouTube" frameBorder={0} height={iframeHeight} width={iframeWidth} scrolling="no" allowFullScreen src={`https://www.youtube-nocookie.com/embed/${contentUrl}?autoplay=${autoPlay ? 1 : 0}`} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"/>
               }
               { linkType === LinkAssetType.Vimeo &&
                    <iframe title="Vimeo" frameBorder={0} height={iframeHeight} width={iframeWidth} scrolling="no" allow="autoplay" allowFullScreen src={`https://player.vimeo.com/video/${contentUrl}?autoplay=${autoPlay ? 1 : 0}&color=231967d&title=0&byline=0`}/>
               }
            </DialogContent>
        </Dialog>
    );
}